<div id="content" class="app-content mt-5">
    <div id="footer" class="app-footer mx-0 px-0 row">

        <div class="col-md-6 col-sm-6">
            <span class="txt-color-white">{{appname}} © 2019-{{date| date:'yyyy'}} |</span>
            <a [routerLink]="['/privacy']"><span class="txt-color-white"> Privacy Policy</span></a>
            <span class="txt-color-white"> |
                <a [routerLink]="['/termsofuse']" class="txt-color-white"> Terms of use</a> </span>
            <span class="txt-color-white"> |
                <a [routerLink]="['/aboutus']" class="txt-color-white"> About Us</a> </span>
        </div>
        <div class="col-md-6 col-sm-6  ">
            <p class="text-right txt-color-white font-xs float-end">Quotator360.com is a service provided by MRUA, a
                company
                regulated and authorized by DFSA.
            </p>
        </div>
        <div class="col-xs-6 col-sm-6 text-right hidden-xs d-none">
            <div class="txt-color-white inline-block">
                <i class="txt-color-blueLight hidden-mobile">Last account activity <i class="fa fa-clock-o"></i>
                    <strong>52 mins ago &nbsp;</strong> </i>

                <div class="btn-group" dropdown [dropup]="true">
                    <button class="btn btn-xs dropdown-toggle bg-color-blue txt-color-white" dropdownToggle>
                        <i class="fa fa-link"></i> <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" *dropdownMenu style="right: 0px; left: auto">
                        <li>
                            <div class="padding-5">
                                <p class="txt-color-darken font-sm no-margin">Download Progress</p>

                                <div class="progress progress-micro no-margin">
                                    <div class="progress-bar progress-bar-success" style="width: 50%;"></div>
                                </div>
                            </div>
                        </li>
                        <li class="divider"></li>
                        <li>
                            <div class="padding-5">
                                <p class="txt-color-darken font-sm no-margin">Server Load</p>

                                <div class="progress progress-micro no-margin">
                                    <div class="progress-bar progress-bar-success" style="width: 20%;"></div>
                                </div>
                            </div>
                        </li>
                        <li class="divider"></li>
                        <li>
                            <div class="padding-5">
                                <p class="txt-color-darken font-sm no-margin">Memory Load <span
                                        class="text-danger">*critical*</span>
                                </p>

                                <div class="progress progress-micro no-margin">
                                    <div class="progress-bar progress-bar-danger" style="width: 70%;"></div>
                                </div>
                            </div>
                        </li>
                        <li class="divider"></li>
                        <li>
                            <div class="padding-5">
                                <button class="btn btn-block btn-default">refresh</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</div>